import type { ParsedUrlQuery } from "node:querystring";

export function getCheckoutInterval(query: ParsedUrlQuery) {
  return getQuery(query.checkout) === "monthly" ? "monthly" : undefined;
}

export function withAuthContext(path: string, query: ParsedUrlQuery) {
  const params = new URLSearchParams();
  const sessionId = getQuery(query.saveSession);
  const returnTo = getQuery(query.returnTo);
  const checkout = getCheckoutInterval(query);

  if (sessionId) params.set("saveSession", sessionId);
  if (returnTo) params.set("returnTo", returnTo);
  if (checkout) params.set("checkout", checkout);
  if (!params.size) return path;

  return `${path}${path.includes("?") ? "&" : "?"}${params}`;
}

export function getQuery(value: string | string[] | undefined) {
  return Array.isArray(value) ? value[0] : value;
}
